export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PartnerSubscriptionTerms.vue?vue&type=template&id=42ae4c02&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/partner/sections/PartnerSubscriptionTerms.vue?vue&type=template&id=42ae4c02&scoped=true&
// module id = 1568
// module chunks = 0